import React from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import { money } from './logic';
import { averagePriceTooltip, averageSellPrice, currentPrice } from './priceFormatting';
import { CommandDeparture } from './types';

export default function DeparturePrice({ departure }: { departure: CommandDeparture }) {
  return (
    <Box sx={{ color: 'text.primary', fontVariantNumeric: 'tabular-nums', fontSize: 12 }}>
      <Tooltip title={averagePriceTooltip(departure)}>
        <Box component="span" tabIndex={0}>
          Avg sold {money(averageSellPrice(departure).all)} / traveller
        </Box>
      </Tooltip>
      <Typography variant="caption" display="block" color="text.secondary">
        Now {currentPrice(departure)}
      </Typography>
    </Box>
  );
}
